// R216: EXTRACTED FROM `src/App.tsx`. It is its own module rather than an export of the spellbook
// because the Magic Room SCENE uses it too, and a hook exported from a component file is a second
// thing to find. It holds two hooks, so a gate cannot CALL it — the reach it buys is the IMPORT.
import { useEffect, useState } from "react";

// prefers-reduced-motion: the whole book animation degrades to instant, honest swaps.
export function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = useState(false);
  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    const on = () => setReduced(mq.matches);
    on();
    mq.addEventListener?.("change", on);
    return () => mq.removeEventListener?.("change", on);
  }, []);
  return reduced;
}
